<template>
  <div class="about-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="section-container">
        <h1 class="page-header__title">Tentang Kami</h1>
        <div class="page-header__breadcrumb">
          <router-link to="/solusi-it">Solusi IT</router-link>
          <span>/</span>
          <span>Tentang Kami</span>
        </div>
      </div>
    </div>

    <!-- About Content -->
    <section class="section">
      <div class="section-container">
        <div class="about-intro animate-on-scroll">
          <div class="about-intro__content">
            <span class="badge-label">
              <span class="badge-label__dot"></span>
              Siapa Kami?
            </span>
            <h2>Selamat Datang di <span class="text-gradient">Miraverse.ID</span></h2>
            <p class="about-intro__lead">Partner terpercaya Anda dalam dunia digital. Kami adalah tim profesional yang berkomitmen untuk menghadirkan solusi teknologi yang inovatif dan efektif, membantu bisnis Anda mencapai potensi terbaiknya.</p>
          </div>
        </div>

        <!-- Vision & Mission -->
        <div class="vm-grid animate-on-scroll">
          <div class="vm-card">
            <div class="vm-card__icon"><i class="fa fa-eye"></i></div>
            <h3>Visi Kami</h3>
            <p>Memudahkan bisnis dalam bertransformasi ke era digital. Kami percaya bahwa setiap perusahaan, besar atau kecil, berhak mendapatkan alat dan teknologi yang tepat untuk berkembang dan bersaing di pasar global.</p>
          </div>
          <div class="vm-card vm-card--accent">
            <div class="vm-card__icon"><i class="fa fa-rocket"></i></div>
            <h3>Misi Kami</h3>
            <p>Menghadirkan solusi teknologi berkualitas tinggi yang terjangkau. Membangunkan hubungan jangka panjang dengan klien melalui layanan yang prima dan inovatif.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Us Section -->
    <section class="section section--alt">
      <div class="section-container">
        <div class="section-title animate-on-scroll">
          <span class="badge-label">
            <span class="badge-label__dot"></span>
            Keunggulan
          </span>
          <h2>Mengapa Memilih <span class="text-gradient">Kami?</span></h2>
        </div>
        <div class="values-grid animate-on-scroll">
          <div class="value-card" v-for="(value, index) in values" :key="index">
            <div class="value-card__icon"><i :class="value.icon"></i></div>
            <h4>{{ value.title }}</h4>
            <p>{{ value.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="section section--gradient">
      <div class="section-container">
        <div class="about-cta animate-on-scroll">
          <h2>Bergabunglah Bersama Kami!</h2>
          <p>Mari wujudkan visi digital Anda bersama Miraverse.ID. Hubungi kami hari ini untuk mendiskusikan bagaimana kami dapat membantu bisnis Anda tumbuh dan sukses.</p>
          <router-link to="/contact" class="btn-primary-custom" style="background: #fff; color: #6C2973;">Hubungi Kami</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
    return {
      values: [
        { icon: 'fa fa-check-circle', title: 'Solusi Kustom', desc: 'Setiap bisnis memiliki tantangan unik. Kami menawarkan solusi yang disesuaikan untuk kebutuhan spesifik Anda.' },
        { icon: 'fa fa-users', title: 'Tim Berpengalaman', desc: 'Tim kami terdiri dari profesional berpengalaman di bidang teknologi dan bisnis digital.' },
        { icon: 'fa fa-headphones', title: 'Layanan Responsif', desc: 'Kami berkomitmen untuk mendukung Anda di setiap langkah perjalanan digital Anda dengan layanan pelanggan yang responsif.' },
        { icon: 'fa fa-shield', title: 'Keamanan Terjamin', desc: 'Kami menerapkan standar keamanan tinggi untuk melindungi data dan sistem Anda.' },
        { icon: 'fa fa-line-chart', title: 'Hasil Terukur', desc: 'Setiap proyek kami dirancang untuk memberikan dampak yang terukur bagi bisnis Anda.' },
        { icon: 'fa fa-refresh', title: 'Inovasi Berkelanjutan', desc: 'Kami terus mengikuti perkembangan teknologi terbaru untuk memberikan solusi terbaik.' }
      ]
    }
  },
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { entry.target.classList.add('animated') }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.text-gradient {
  background: linear-gradient(135deg, #6C2973, #C73468);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.about-intro {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 60px;

  &__lead {
    font-size: 1.1rem;
    color: $text-body;
    margin-top: 16px;
    line-height: 1.8;
  }
}

.vm-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.vm-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 24px rgba(108, 41, 115, 0.06);
  border: 1px solid rgba(108, 41, 115, 0.06);

  h3 {
    margin: 16px 0 12px;
  }

  p {
    color: $text-body;
    line-height: 1.8;
  }

  &--accent {
    background: linear-gradient(135deg, #6C2973, #C73468);

    h3, p { color: #fff; }

    .vm-card__icon {
      background: rgba(255, 255, 255, 0.15);
      color: #fff;
    }
  }
}

.vm-card__icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: rgba(108, 41, 115, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #6C2973;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.value-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(108, 41, 115, 0.06);
  transition: all 0.3s ease;
  border: 1px solid rgba(108, 41, 115, 0.06);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(108, 41, 115, 0.12);
  }

  h4 { margin: 16px 0 10px; }
  p { font-size: 0.9rem; color: $text-body; line-height: 1.7; }
}

.value-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(108, 41, 115, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #6C2973;
  transition: all 0.3s ease;
}

.value-card:hover .value-card__icon {
  background: linear-gradient(135deg, #6C2973, #C73468);
  color: white;
}

.about-cta {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;

  h2 { color: #fff; margin-bottom: 16px; }
  p { color: rgba(255, 255, 255, 0.85); margin-bottom: 28px; }
}

@media (max-width: 991px) {
  .vm-grid { grid-template-columns: 1fr; }
  .values-grid { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 576px) {
  .values-grid { grid-template-columns: 1fr; }
}
</style>
